'use client';
import React from 'react';

import { MODAL_NAMES } from '@/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';
import { AddressNotFoundModal } from '../address-not-found-modal';
import { GasAddressNotFoundModal } from '../gas-address-not-found-modal';
import { OutsideServiceAreaModal } from '../outside-service-area-modal';

function JoinFormModalRenderer() {
  const { getCurrentModal, closeModal, resetProperty } = useJoinFormStore();

  const currentModal = getCurrentModal();

  return (
    <>
      <OutsideServiceAreaModal
        isModalOpen={currentModal === MODAL_NAMES.OutsideServiceArea}
        setIsModalOpen={() => closeModal(MODAL_NAMES.OutsideServiceArea)}
        onCancel={resetProperty}
      />
      <AddressNotFoundModal
        isModalOpen={currentModal === MODAL_NAMES.AddressNotFound}
        setIsModalOpen={() => closeModal(MODAL_NAMES.AddressNotFound)}
      />
      <GasAddressNotFoundModal
        isModalOpen={currentModal === MODAL_NAMES.GasAddressNotFound}
        setIsModalOpen={() => closeModal(MODAL_NAMES.GasAddressNotFound)}
      />
    </>
  );
}

export default JoinFormModalRenderer;
